import { appendQueryParams } from '@office-start/url-parser-utility';
var graphV1 = 'v1.0';
var graphBeta = 'beta';
export function getGraphServiceEndpoint(apiRoot, endpoint, beta, queryParams) {
    if (beta === void 0) { beta = false; }
    var url = "".concat(apiRoot, "/").concat(beta ? graphBeta : graphV1, "/").concat(endpoint);
    // Add query params to url
    if (queryParams) {
        url = appendQueryParams(url, queryParams);
    }
    return url;
}
//# sourceMappingURL=getGraphServiceEndpoint.js.map